<template>
    <div v-if="show" class="ufo--file-dz-loader">
        <img src="../../images/loadinganim.gif" width="80" height="80" alt="File upload loader" />
    </div>
</template>

<script>
export default {
    name: 'LoaderOverlay',
    props: {
        show: {
            type: Boolean,
            default: false
        }
    }
}
</script>

<style lang="scss" scoped>
.ufo--file-dz-loader {
    width: calc(100% - 4px);
    height: calc(100% - 4px);
    background-color: rgba(25, 33, 37, 0.5);
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 11;
    
    img {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
}
</style>